import { all, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { DEVIATIONS_PER_FETCH, MEDIA_POPUP_TIER_DEVIATION_STREAM_GROUP } from '../constants';
import { getTierDeviationsStreamId } from '../helpers';
import { getCurrentMediaSource, getMode, getCurrentTierId } from '../selectors';
import { MediaPopupMode } from '../types';
function* handleInitTierDeviationStream() {
    const { mode , mediaSource , tierId  } = yield select((state)=>({
            mode: getMode(state),
            mediaSource: getCurrentMediaSource(state),
            tierId: getCurrentTierId(state)
        }));
    const streamId = getTierDeviationsStreamId(mediaSource, tierId);
    const isStreamInitialized = yield select(selectors.isInitialized, streamId);
    let cacheStreams = true;
    if (mode === MediaPopupMode.MANAGER) {
        cacheStreams = false;
    }
    if (isStreamInitialized && cacheStreams) {
        return;
    }
    const streamParams = {
        mediaSource,
        tierId
    };
    yield all([
        put(withOffset.actions.initialize({
            streamId,
            groupId: MEDIA_POPUP_TIER_DEVIATION_STREAM_GROUP,
            streamParams,
            itemsPerFetch: DEVIATIONS_PER_FETCH,
            hasMore: true
        })),
        put(withOffset.actions.fetch(streamId))
    ]);
}
export default handleInitTierDeviationStream;
